<div class="bottom-bar" [ngClass]="{'mobile': sharedDataService.isHandset$ | async}">
  <div class="employee-login">
    @if (!isLoggedIn()) {
      <button mat-button (click)="openLoginDialog()">Mitarbeiter-Login</button>
    }
    @if (isLoggedIn()) {
      <button mat-button (click)="logout()">Ausloggen</button>
    }
  </div>
  <div class="legal">
    <a href="{{ constants.termsAndConditions }}">AGB</a>
    <a href="{{ constants.imprint }}">Impressum</a>
    <a href="{{ constants.privacyStatement }}">Datenschutzerklärung</a>
    <a href="{{ constants.licenses }}">Lizenzen</a>
  </div>
  <p class="version">| Neo Learning by aiddevs. Version: {{ version }}</p>
</div>
